import React, { Component } from "react"
import { Link } from "react-router-dom"
import glamorous from "glamorous"
import style from "utils/style"

class ModalView extends Component {
  render() {
    return (
      <Flex>
        <Container>
          <Title>{this.props.title}</Title>
          {this.props.children}
          <Button>{this.props.buttonText}</Button>
          <LinkContainer>
            {this.props.links ? (
              this.props.links.map(link => (
                <StyledLink to={link.route}>{link.name}</StyledLink>
              ))
            ) : null}
          </LinkContainer>
        </Container>
      </Flex>
    )
  }
}

export default ModalView

const Flex = glamorous.div({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  flexDirection: "row",
})

const Container = glamorous.div({
  padding: 0,
  margin: "50px 0 50px 0",
  borderRadius: 10,
  textAlign: "center",
  border: `1px solid ${style.colors.mutedOlive}`,
  width: "40%",
  "@media (max-width: 750px)": {
    width: "80%",
  },
})
const Title = glamorous.h1({
  fontSize: 24,
  margin: "20px 15px 20px 15px",
})

const Button = glamorous.a({
  background: style.colors.primaryBlue,
  borderRadius: 10,
  color: "white",
  padding: 15,
  margin: "10px 10% 10px 10%",
  display: "inline-block",
  textDecoration: "none",
  ":hover": {
    background: style.colors.darkerPrimaryBlue,
  },
  "@media (max-width: 750px)": {
    marginBottom: 20,
  },
})
const StyledLink = glamorous(Link)({
  display: "block",
  textAlign: "left",
  marginTop: 10,
  fontSize: 14,
  color: style.colors.darkerPrimaryBlue,
})
const LinkContainer = glamorous.div({
  backgroundColor: style.colors.veryLightGray,
  padding: "10px 20px 20px 20px",
  marginTop: 20,
  borderRadius: "0px 0px 10px 10px",
})



// WEBPACK FOOTER //
// ./src/containers/ModalView/index.js